/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageGrid/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ImageSlot from './ImageSlot/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageGrid({
  children,
  viewPath = "/DesignSystem/ImageViewGrid/ImageGrid",
  onImageAnalyze
  
}) {
let gridImagesValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'images',
})
let gridColumnsValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'columns',
})
let gridCellValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'cell',
})
let aggregateData = fromHelpers.getGridTemplate(gridColumnsValueData, gridCellValueData)
let gridRowsValueData = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'rows',
})
let gridCellValueData1 = fromData.useDataValue({ viewPath,
context: 'grid',
path: 'cell',
})
let aggregateData1 = fromHelpers.getGridTemplate(gridRowsValueData, gridCellValueData1)
  return (<React.Fragment
>
<div
  data-testid="ImageGrid.List"
  data-view-path={viewPath}
 style={{'--gtc-1-1khexM': aggregateData,'--gtr-2-1khexM': aggregateData1}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(gridImagesValueData) && gridImagesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="image_slot"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/ImageSlot(${item?.id ?? item?._id ?? index})`}
      >
<ImageSlot
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/ImageSlot(${item?.id ?? item?._id ?? index})`}
 onImageAnalyze={onImageAnalyze}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }